<template>
  <v-row>
    <v-col cols="12" sm="6">
      <v-card class="time-range">
        <v-row class="pa-4">
          <v-col cols="12">
            <h2 class="title">Time Range</h2>
            <v-divider class="pb-4"/>
              <time-range @dateRange="setDateRange"/>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-col cols="12" sm="6">
      <v-card>
        <v-row class="pa-4">
          <v-col cols="12">
            <h2 class="title">Nets Filters</h2>
            <v-divider class="pb-4"/>
              <v-btn block color="primary" class="my-2" @click="cropFilter('KIWI_YELLOW')">KIWI YELLOW Nets</v-btn>
              <v-btn block color="primary" class="mb-2" @click="cropFilter('KIWI_RED')">KIWI RED Nets</v-btn>
              <v-btn block color="primary" class="mb-2" @click="cropFilter('KIWI_G11')">KIWI G11 Nets</v-btn>
              <v-btn block color="primary" class="mb-4" @click="cropFilter('KIWI_G14')">KIWI G14 Nets</v-btn>
              <v-select
                v-model="netNameSelected"
                :items="netNameFilters"
                @change="setNameFilter"
                multiple
                hint="Nets"
                label="Nets"
                ></v-select>
              <v-select
                v-model="netNationSelected"
                :items="netNationFilters"
                @change="setNationFilter"
                label="Nation"
                ></v-select>
              <v-select
                v-if="netAreaFilters.length"
                v-model="netAreaSelected"
                :items="netAreaFilters"
                @change="setAreaFilter"
                label="Area"
                ></v-select>
              <v-select
                v-if="netRegionFilters.length"
                v-model="netRegionSelected"
                :items="netRegionFilters"
                @change="setRegionFilter"
                label="Region"
                ></v-select>
              <v-btn block color="primary" class="mb-2" @click="resetFilters()">All Nets</v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<style>
.time-range{
  height: 100%;
}
</style>

<script>
import TimeRange from "@/components/TimeRange";
export default {
  components: {
    timeRange: TimeRange
  },
  name: "NetsFilters",
  props: ["nets"],
  data () { return {
    netNameSelected: '',
    netNationSelected: '',
    netAreaSelected: '',
    netRegionSelected: '',
    netAreaFilters: [],
    netRegionFilters: [],
    netNationFilters: [],
    netNameFilters: [],
    netCrop: '',
    dateRange: {},
    dataResolution: "1h"
  }},
  computed:{
    filteredNets: function () {
      if (this.netNameSelected.length) return this.nets.filter((net) => {
        return this.netNameSelected.includes(net.name)
      })
      if (this.netNationSelected) {
        let nationNets = this.nets.filter((net) => this.netNationSelected.includes(net.nation))
        let filteredNetNations = nationNets.filter((net)=> this.netRegionSelected.includes(net.region) || this.netAreaSelected.includes(net.area))
        return filteredNetNations.length ? filteredNetNations : nationNets
    }
      if (this.netCrop.length) {
        return this.nets.filter((net) => net.crop.includes(this.netCrop))
    }
      return this.nets
    } 
  },
  created: function () {
    this.getNetsFilters()
  },
  methods: {
    setNameFilter(){
      this.netRegionFilters = []
      this.netAreaFilters = []
      this.netNationSelected = ''
      this.netCrop = ''
      this.netRegionSelected = ''
      this.netAreaSelected = ''
      this.commitOnStore()
    },
    setAreaFilter(){
      this.netRegionSelected = ''
      this.netNameSelected = ''
      this.netCrop = ''
      this.commitOnStore()
    },
    setRegionFilter(){
      this.netAreaSelected = ''
      this.netCrop = ''
      this.netNameSelected = ''
      this.commitOnStore()
    },
    setNationFilter(){
      this.netNameSelected = ''
      this.netCrop = ''
      this.netRegionSelected = ''
      this.netAreaSelected = ''
      let areaFilters = new Set()
      let regionFilters = new Set()
      this.filteredNets.forEach( (net) => {
        areaFilters.add(net.area)
        regionFilters.add(net.region)
      })
      this.netAreaFilters = Array.from(areaFilters).filter(Boolean).sort()
      this.netRegionFilters = Array.from(regionFilters).filter(Boolean).sort()
      this.commitOnStore()
    },
    getNetsFilters(){
      let netFilters = new Set()
      let nationFilters = new Set()
      this.nets.forEach( (net) => {
        netFilters.add(net.name)
        nationFilters.add(net.nation)
      })
      this.netNameFilters = Array.from(netFilters).filter(Boolean).sort()
      this.netNationFilters = Array.from(nationFilters).filter(Boolean).sort()
    },
    setDateRange(dateRange){
      this.dateRange = dateRange.dates
      this.dataResolution = dateRange.resolution
      this.commitOnStore()
    },
    commitOnStore(){
      this.$store.commit('SET_SENSORS_QUERY', {
        nets: this.filteredNets,
        graphType: this.graphType,
        measurement: this.measurement,
        dataResolution: this.dataResolution,
        dateRange: this.dateRange,
        minmaxdata: this.minmaxdata
      })
    },
    resetFilters(){
      this.netNameSelected = ''
      this.netCrop = ''
      this.setNameFilter()
    },
    cropFilter(crop){
      this.netRegionFilters = []
      this.netAreaFilters = []
      this.netNameSelected = ''
      this.netNationSelected = ''
      this.netRegionSelected = ''
      this.netAreaSelected = ''
      this.netCrop = crop 
      this.commitOnStore()
    }
  }
};
</script>
